import React, { createContext } from 'react';
import useSWR from 'swr';

// Create context for feature flags
export const FeatureFlagContext = createContext({
  flags: {},
  isLoading: true,
  error: null,
  refreshFlags: () => {},
});

/**
 * Provider component for feature flags
 * @param {object} props - Component props
 * @param {React.ReactNode} props.children - Child components
 * @returns {JSX.Element} - Provider component
 */
export const FeatureFlagProvider = ({ children }) => {
  const {
    data: flags = {},
    isLoading,
    error,
    mutate,
  } = useSWR('/api/v2/feature-flag', {
    refreshInterval: 60000,
    revalidateOnFocus: false,
    revalidateOnReconnect: true,
  });

  const value = {
    flags,
    isLoading,
    error,
    refreshFlags: () => mutate(),
  };

  return (
    <FeatureFlagContext.Provider value={value}>
      {children}
    </FeatureFlagContext.Provider>
  );
};

export default FeatureFlagProvider;
